export default __webpack_public_path__ + "static/media/Sales Manager.261366fc.png";